import React from "react";
import { Button, Form, FormControl, Modal, DropdownButton, Dropdown } from "react-bootstrap";
import { formatAllowWebText, formatSuperAdminText } from "../../components/CONSTANTS";
import { updateUserAsAdmin } from "../../services/AdminService";

export const EditUserAsAdminModal = ({ firstName, lastName, userid, email, company, allowWeb, superadmin }) => {

    const [show, setShow] = React.useState(false);
    const [edit, setEdit] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [superadminRef, setSuperAdminRef] = React.useState(false);
    const [allowWebRef, setAllowWebRef] = React.useState(false);
    const [firstnameRef, setFirstnameRef] = React.useState("");

    const updateUser = async () => {

        let insertBool = Boolean(allowWebRef)
        try {

            setLoading(true);
            await updateUserAsAdmin(userid, allowWebRef);
            setLoading(false);
        } catch {

        }
    }

    const handleSelect = (e) => {
        setAllowWebRef(e);
    }

    return (
        <>
            <Button disabled={loading} onClick={() =>
                setShow(!show)
            } variant={"warning"}>
                Redigera Användare {firstName} {lastName}
            </Button>

            <Modal show={show}>
                <Modal.Header>
                    Redigera användare {firstName} {lastName}
                </Modal.Header>
                <Modal.Body>

                    Förnamn: {firstName}
                    <hr />
                    Efternamn: {lastName}
                    <hr />
                    Email: {email}
                    <hr />
                    Rättigheter: {formatAllowWebText(allowWeb)}
                    <hr />
                    <Form.Group>

                        <DropdownButton
                            alignRight
                            title="Ange App/Webb-behörighet"
                            id="dropdown-menu-align-right"
                            onSelect={handleSelect}
                        >
                            <Dropdown.Item eventKey="Webb">Webb</Dropdown.Item>
                            <Dropdown.Item eventKey="App">App</Dropdown.Item>
                        </DropdownButton>
                    </Form.Group>

                    <hr />
                    Företag: {company}

                    <hr />
                    AnvändarID:{userid}(går ej redigera)

                    <Button variant="primary" disabled={loading} onClick={() => setShow(false)}>
                        Stäng
                    </Button>
                    <Button variant="success" disabled={loading} onClick={() => updateUser()}>
                        Spara Ändringar
                    </Button>
                </Modal.Body>
            </Modal>
        </>
    )
}